@if (skeleton()) {
  <div class="umss-pagination umss-pagination--skeleton" aria-hidden="true">
    <div
      class="umss-pagination__skeleton-btn umss-pagination__skeleton-btn--wide"
    ></div>
    <div class="umss-pagination__skeleton-btn"></div>
    <div class="umss-pagination__skeleton-btn"></div>
    <div class="umss-pagination__skeleton-btn"></div>
    <div
      class="umss-pagination__skeleton-btn umss-pagination__skeleton-btn--wide"
    ></div>
  </div>
} @else {
  <nav class="umss-pagination" aria-label="Pagination">
    <umss-button
      class="umss-pagination__control umss-pagination__control--previous"
      label="Previous"
      variant="Ghost"
      size="Small"
      leftIconName="phosphorCaretLeft"
      [iconOnly]="!showLabels()"
      [disabled]="displayPage() <= 1"
      (onClick)="onPrevious()"
    />

    <ul class="umss-pagination__pages">
      @for (item of pageItems(); track item) {
        <li class="umss-pagination__page-item">
          @if (item === 'ellipsis-left') {
            <button
              class="umss-pagination__ellipsis"
              [style.display]="activeInput() ? 'none' : 'inline-flex'"
              type="button"
              aria-label="More numbers in here"
            >
              …
            </button>
          } @else if (item === 'ellipsis-right') {
            <button
              class="umss-pagination__ellipsis"
              [style.display]="activeInput() ? 'none' : 'inline-flex'"
              type="button"
              aria-label="More numbers in here"
            >
              …
            </button>
          } @else if (displayPage() === item) {
            @if (activeInput()) {
              <input
                #pageInput
                class="umss-pagination__ellipsis-input"
                type="number"
                [formControl]="activeInputValue"
                [min]="1"
                [max]="totalPages()"
                [placeholder]="displayPage()"
                (keydown)="onInputKeydown($event)"
                (blur)="onInputBlur()"
              />
            } @else {
              <umss-button
                class="umss-pagination__page-button"
                [label]="$any(item).toString()"
                size="Small"
                [variant]="'Secondary'"
                (onClick)="onCurrentPageClick()"
              />
            }
          } @else {
            <umss-button
              class="umss-pagination__page-button"
              [label]="$any(item).toString()"
              size="Small"
              [variant]="'Ghost'"
              (onClick)="onPageClick($any(item))"
            />
          }
        </li>
      }
    </ul>

    <umss-button
      class="umss-pagination__control umss-pagination__control--next"
      label="Next"
      variant="Ghost"
      size="Small"
      rightIconName="phosphorCaretRight"
      [iconOnly]="!showLabels()"
      [disabled]="displayPage() >= totalPages()"
      (onClick)="onNext()"
    />
  </nav>
}
